module.exports = __webpack_public_path__ + "img/165.1cc8ba52.jpg";